import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

export interface AssetInfo {
  asset_name: string
  created_on: string
  description: string
  image: string
  site_id?: string
}

export interface AssetInfoState {
  isLoading: boolean
  loadingError: string | null
  assetInfo: AssetInfo | null
  httpStatus: number | null
}

export const initialState: AssetInfoState = {
  isLoading: true,
  loadingError: null,
  assetInfo: null,
  httpStatus: null
}

const assetInfoSlice = createSlice({
  name: 'gatewayManagementAssetInfo',
  initialState,
  reducers: {
    assetInfoLoadingAction: (state) => {
      return {
        isLoading: true,
        loadingError: null,
        assetInfo: null,
        httpStatus: 0
      }
    },
    assetInfoUpdateAction: (state, action: PayloadAction<{ data: AssetInfo, httpStatus: number }>) => {
      return {
        isLoading: false,
        loadingError: null,
        assetInfo: action.payload.data,
        httpStatus: action.payload.httpStatus
      }
    },
    assetInfoErrorAction: (state, action: PayloadAction<{ errorMessage: string, httpStatus: number }>) => {
      return {
        isLoading: false,
        loadingError: action.payload.errorMessage,
        assetInfo: null,
        httpStatus: action.payload.httpStatus
      }
    }
  }
})

export const {
  assetInfoLoadingAction,
  assetInfoUpdateAction,
  assetInfoErrorAction
} = assetInfoSlice.actions

export default assetInfoSlice.reducer
